import React from 'react';
import { InputNumber } from 'formik-antd';
import FormControl from '~/components/Form/FormControl';
import { SelectAntd, SelectAntdFormik } from '~/components/Pagination/styles';
import InputCurrency from '~/components/Form/InputCurrency';
import Button from '~/components/Button';
import i18next from 'i18next';
import { FaTrash } from 'react-icons/fa';
import { Typography } from 'antd';
import { formatPrice, parsePrice } from '~/Utils/format';

export const servicesEventColumns = (services, errors, fluidPermissions, values, setFieldValue) => {
  return [
    {
      title: i18next.t('fields:event.service.name'),
      dataIndex: 'service_id',
      key: 'service_id',
      width: '40%',
      render: (_, record, index) => (
        <FormControl
          field={`services_events.${index}.service.id`}
          error={errors?.services_events?.[index]?.service?.id}
          list
          required
        >
          <SelectAntdFormik
            placeholder="SELECIONE"
            name={`services_events.${index}.service.id`}
            showSearch
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            disabled={!fluidPermissions()}
          >
            {services?.map((item) => (
              <SelectAntd.Option key={item.id} value={item.id}>
                {item.name}
              </SelectAntd.Option>
            ))}
          </SelectAntdFormik>
        </FormControl>
      ),
    },
    {
      title: i18next.t('fields:event.service.amount'),
      dataIndex: 'amount',
      key: 'amount',
      render: (_, record, index) => (
        <FormControl
          field={`services_events.${index}.amount`}
          error={errors?.services_events?.[index]?.amount}
          list
          required
        >
          <InputNumber
            name={`services_events.${index}.amount`}
            disabled={!fluidPermissions()}
            onChange={(value) => {
              setFieldValue(`services_events.${index}.amount`, value);

              const currentPrice = values?.services_events?.[index]?.price_unit || 0;
              const total = Number(value || 0) * parsePrice(currentPrice);

              setFieldValue(`services_events.${index}.price_total`, total);
            }}
          />
        </FormControl>
      ),
    },
    {
      title: i18next.t('fields:event.service.priceUnit'),
      dataIndex: 'price_unit',
      key: 'price_unit',
      render: (_, record, index) => (
        <FormControl
          field={`services_events.${index}.price_unit`}
          error={errors?.services_events?.[index]?.price_unit}
          list
          required
        >
          <InputCurrency
            name={`services_events.${index}.price_unit`}
            disabled={!fluidPermissions()}
            onChange={(e) => {
              const newPrice = e?.target ? e.target.value : e;

              setFieldValue(`services_events.${index}.price_unit`, newPrice);

              const currentAmount = values?.services_events?.[index]?.amount || 0;
              const total = Number(currentAmount) * parsePrice(newPrice);

              setFieldValue(`services_events.${index}.price_total`, total);
            }}
          />
        </FormControl>
      ),
    },
    {
      title: 'Total',
      dataIndex: 'price_total',
      key: 'price_total',
      render: (_, record, index) => {
        const realTimeTotal = values?.services_events?.[index]?.price_total || 0;
        return <Typography.Text strong>{formatPrice(realTimeTotal)}</Typography.Text>;
      },
    },
    {
      title: '',
      key: 'action',
      render: (_, record, index) => (
        <Button
          color="danger"
          title="Remover serviço"
          size="small"
          style={{ width: '30px' }}
          onClick={() => record.remove(index)}
          disabled={!fluidPermissions()}
          icon={<FaTrash />}
        />
      ),
    },
  ];
};
